import { ResponseTO } from '../types/response-to.type';
import axios, { AxiosError } from 'axios';
import { handleResponseError } from './webservice';
import { PaymentConfig } from '../types/payment-config.type';
import { Coupon } from '../types/coupon.type';

const BASE_URL = process.env.REACT_APP_PAYMENTS_API_URL;
const BASE_URL2 = process.env.REACT_APP_PAYMENTS_API_V2_URL;
const TOKEN = process.env.REACT_APP_PANA_API_TOKEN;

const fetchConfig = async (): Promise<ResponseTO<PaymentConfig>> => {
    try {
        const response = await axios.get<ResponseTO>(
            `${BASE_URL}/v1/payments/config`,
            { headers: { Authorization: `Bearer ${TOKEN}` } }
        );
        return response.data;
    } catch (err) {
        return handleResponseError(err as AxiosError);
    }
};

const checkCouponCode = async (code: string): Promise<ResponseTO<Coupon>> => {
    try {
        const response = await axios.get<ResponseTO>(
            `${BASE_URL}/v1/coupons/codes/${code}`,
            { headers: { Authorization: `Bearer ${TOKEN}` } }
        );
        return response.data;
    } catch (err) {
        return handleResponseError(err as AxiosError);
    }
};

/*** Junior Sanabria ***/
const fetchBanks = async (token: string): Promise<any[]> => {
    try {
        const response = await axios.get<any[]>(
            // Asumiendo que el endpoint de bancos está en la misma base URL de pagos
            `${BASE_URL2}/banks`,
            {
                headers: {
                    // Se usa el token del usuario (oauthToken) para autenticación
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        // Retorna la lista de bancos directamente
        return response.data;
    } catch (err) {
        console.error('Error fetching banks:', err);
        // Devuelve un array vacío para evitar errores en plan.view.tsx
        return [];
    }
};
/*** --- ***/

export const paymentsSDK = {
    fetchConfig,
    checkCouponCode,

    fetchBanks,
};
